import {createFetchableSlice} from '../../utils/createFetchableSlice';
import {fetchDetails} from '../../Api';

export const detailsSlice = createFetchableSlice({
    name: 'details',
    fetchable: fetchDetails
});

export default detailsSlice.reducer;